import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
// //Import Scrollbar
import SimpleBar from "simplebar-react"
// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()

  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            {Roles?.Dashview === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/dashboard">
                    <i className="bx bxs-home-circle"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.EmployeeManagmentView === true ||
            Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-wallet-alt"></i>
                    <span>{props.t("Staff Managment")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.departementView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Departments">
                            {props.t("Departments")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.rolesAndPermissionView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/RolesPremissions">
                            {props.t("Roles & Premissions")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.staffView === true || Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Staff">{props.t("Staff")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.ListingModuleView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="fas fa-list-alt"></i>
                    <span>{props.t("Listing")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.CategoryView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Category">{props.t("Category")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.SubCategoryView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/SubCategory">
                            {props.t("Sub Category")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.FacilitiesView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Facilities">{props.t("Facilities")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.NewListingView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Listing">{props.t("New Listing")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.ProductsAllView === true ||
            Roles?.ProductcatView === true ||
            Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-server"></i>
                    <span>{props.t("Products")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.ProductcatView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/product_cat">{props.t("Category")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.ProductsAllView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/products">{props.t("Products")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {/*   {Roles?.ServicesView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-server"></i>
                    <span>{props.t("Services")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.AllServicesView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/AllServices">
                            {props.t("All Services")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.PendingServicesView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PendingServices">
                            {props.t("Pending Services")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.CompletedServicesView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/CompletedServices">
                            {props.t("Completed Services")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}
             */}

            {/* adding the new component name is "Uploads" */}
            {Roles?.UploadModuleView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/Uploads">
                    <i className="fa fa-camera"></i>
                    <span>{props.t("Uploads")}</span>
                  </Link>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.UploadModuleView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/agents">
                    <i className="bx bx-user-pin"></i>
                    <span>{props.t("Agents")}</span>
                  </Link>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.PostersModuleView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-carousel"></i>
                    <span>{props.t("Posters")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.PostersCategoryView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Templatecategory">
                            {props.t("Posters Category")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.PostersView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Templates">{props.t("Posters")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.BusinessView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-business"></i>
                    <span>{props.t("Business Man")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.pendingBusinessView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PendingVendorsList">
                            {props.t("Pending Business Man")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.pendingBusinessView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Vendor">
                            {props.t("Verified Business Man")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.inActivebusinessView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/InActiveVendors">
                            {props.t("InActive Business Man")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.inActivebusinessView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/RejectedVendors">
                            {props.t("Rejected Business Man")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}

                    {/* adding the new component name is "PendingBusinessManListing" */}
                    {Roles?.pendingBusinessManListingView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PendingBusinessManListing">
                            <span>
                              {props.t("Pending Business Man Listing")}
                            </span>
                          </Link>
                        </li>{" "}
                      </>
                    ) : (
                      ""
                    )}

                    {Roles?.approvedBusinessManListingView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PendingVendorListing">
                            {props.t("Approved Business Man Listing")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.rejectedBusinessManListingView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/VendorListing">
                            {props.t("Rejected Business Man Listing")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {/* adding the new component name is "PendingBusinessManListing" */}
                    {/* <li>
                      <Link to="/PendingBusinessManListing">
                        <span>{props.t("Pending Business Man Listing")}</span>
                      </Link>
                    </li> */}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.usersAllView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-id-card"></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.usersView === true || Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Users">{props.t("Users")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.InActiveUsersView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/BlockedUsers">
                            {props.t("InActive Users")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.PendingUserListingView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PendingUserListing">
                            {props.t("User Listing")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.RejectUserListingView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/UserListing">
                            {props.t("Rejected User Listing")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.plansAllView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-map-alt"></i>
                    <span>{props.t(" Plans")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.plansView === true || Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/VendorPlan">
                            {props.t("Business Man Plans")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.planPaymentsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PlanPayments">
                            {props.t("Business Man Payments")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.userPlansView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/UserPlans">{props.t("User Plans ")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.userPlanPaymentsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/UserPlanPayments">
                            {props.t("User plan Payments ")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.bannersAllView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-image-alt"></i>
                    <span>{props.t("Banners")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.UsersbannerView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Banner">{props.t("User Banners")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.businesBannerView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/VendorBanners">
                            {props.t("Business Man Banners")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.notificationView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/Notification">
                    <i className="fa fa-bell"></i>
                    <span>{props.t("Notifications")}</span>
                  </Link>
                </li>
              </>
            ) : (
              ""
            )}

            {/* <li>
              <Link to="/#" className="has-arrow">
              <i className="fab fa-whatsapp"></i>
                <span>{props.t("Whatsapp")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/whatsapp-template">
                    {props.t("Whatsapp Template")}
                  </Link>
                </li>
                <li>
                  <Link to="/whatsapp-notifications">
                    {props.t("Whatsapp Notifications")}
                  </Link>
                </li>
              </ul>
            </li> */}

            <li>
              <Link to="/whatsapp-notifications">
              <i className="fab fa-whatsapp"></i>
                <span>{props.t("Whatsapp")}</span>
              </Link>
            </li>

            {Roles?.supportView === true || Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-support"></i>
                    <span>{props.t("Support")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.pendingTicketsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PendingSupport">
                            {props.t("Pending Tickets")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.resolvedView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/ResolvedSupport">
                            {props.t("ReSolved Tickets")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.rejectedTicketsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/UnsolvedSupport">
                            {props.t("Rejected Tickets")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}

            {Roles?.SettingManagmentView === true ||
            Roles?.accessAll === true ? (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="fas fa-cogs"></i>
                    <span>{props.t("Settings")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {Roles?.SettingsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/UserCount">{props.t("User Count")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.SettingsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Contact">{props.t("Contact Us")}</Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.SettingsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/PrivacyPolicy">
                            {props.t("Privacy Policy")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    {Roles?.SettingsView === true ||
                    Roles?.accessAll === true ? (
                      <>
                        <li>
                          <Link to="/Terms">
                            {props.t("Terms & Conditions")}
                          </Link>
                        </li>
                      </>
                    ) : (
                      ""
                    )}

                    <li>
                      <Link to="/Community">
                        <span>{props.t("Community")}</span>
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
